import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

import { IcBellSlash16 } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { Button, IconView, IconViewSizes } from '@gem/ui-kit';

import { useSecretChatAccessRequestPresenter } from './SecretChatAccessRequest.presenter';
import styles from './SecretChatAccessRequest.styles.m.css';

interface ISecretChatAccessRequestProps {
  groupId: string;
}

export const SecretChatAccessRequest: FC<ISecretChatAccessRequestProps> = observer((props) => {
  const { groupId } = props;
  const { t } = useTranslation();

  const presenter = useSecretChatAccessRequestPresenter(groupId);

  if (!presenter.isShowSecretChatAccessRequestBanner) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <IconView
          Icon={IcBellSlash16}
          size={IconViewSizes.Small}
          className={styles.icon}
        />
        <div className={styles.username}>
          {presenter.accessRequestsCount > 1
            ? t('secure_chat_requests_to_join_count', {
                0: presenter.accessRequestsCount,
              })
            : t('secure_chat_access_request_title', {
                0: presenter.user?.displayName,
                interpolation: { escapeValue: false },
              })}
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          onClick={presenter.onViewRequests}
          className={styles.action}
          theme="text-secondary"
        >
          {t('common_view')}
        </Button>
      </div>
    </div>
  );
});
